import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { CoreService, HttpService } from '../../services';
import { BObjectModel } from '../../models';
import { ToastService } from '../../toast';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'q-saved-models',
  templateUrl: './saved-models.component.html',
  styleUrls: ['./saved-models.component.css']
})

export class SavedModelsComponent implements OnInit {
  public displayComponent: boolean = true;

  public newModelName: string = '';
  public selectedModel: string = '';
  public emptyModelName: boolean = false;
  
  @Input() model: BObjectModel;
  @Input() value: string;

  @Output('modelChange') modelEmitter: EventEmitter<BObjectModel> = new EventEmitter<BObjectModel>();

  constructor(
    private indParam: CoreService,
    private http: HttpService,
    private toast: ToastService
  ) { }

  ngOnInit(): void {
    if (!this.model || (this.model.IdDonneeFils && this.model.IdDonneeFils != '0') || !this.model.IdentBO || !this.model.Body || !this.model.Body.SelectedGroupsList) {
      this.displayComponent = false;
    }

    this.selectedModel = this.value ? this.value : this.model && this.model.ModelName ? this.model.ModelName : '';

    this.http.getHttp<BObjectModel>(`${this.indParam.AppParams.apiUrl}api/bobject/getData/GET_MODELS/${this.model.IdentBO}|1/`).subscribe
      ((data: BObjectModel) => {
        if (!data.HasSomeError) {
          this.model.Header.SavedModels = data.Header.SavedModels;
        }
      });
  }

  public OnModelChange(value: string): void {
    this.selectedModel = value;
    const model: BObjectModel = JSON.parse(JSON.stringify(this.model));
    model.Mode = 'CREATE_AND_APPLY_MODEL';
    model.ModelName = this.selectedModel;
    this.indParam.showSplash(true);
    this.http.postHttp<BObjectModel>(`${this.indParam.AppParams.apiUrl}api/bobject/`, model).subscribe
      ((data: BObjectModel) => {
        this.indParam.showSplash(false);
        if (!data.HasSomeError) {
          this.model.IdDonneePere = data.IdDonneePere;
          this.model.IdDonneeFils = data.IdDonneeFils;
          this.model.IdRelation = data.IdRelation;
          this.model.CodeRelation = data.CodeRelation;
          this.model.IdentBO = data.IdentBO;
          this.model.NameBO = data.NameBO;
          this.model.IdentBODisplay = data.IdentBODisplay;
          this.model.ShowSaveButton = data.ShowSaveButton;
          this.model.ShowRemoveButton = data.ShowRemoveButton;
          this.model.ShowCreateButton = data.ShowCreateButton;
          this.model.DefaultInputs = data.DefaultInputs;
          this.model.ClientData = data.ClientData;
          this.model.codeProp = data.codeProp;
          this.model.Refresh = data.Refresh;
          this.model.Header.Title = data.Header.Title;
          this.model.Header.ButtonsList = data.Header.ButtonsList;
          this.model.Body = data.Body;
          this.modelEmitter.emit(this.model);
        }
      });
  }

  public SaveModel(): void {
    if (!this.newModelName) {
      this.emptyModelName = true;
      this.toast.showAlertToast('Veuillez renseigner le nom du model');
      return;
    }
    const model: BObjectModel = JSON.parse(JSON.stringify(this.model));
    model.Mode = 'SAVE_MODEL';
    model.ModelName = this.newModelName;
    this.indParam.showSplash(true);
    this.http.postHttp<BObjectModel>(`${this.indParam.AppParams.apiUrl}api/bobject/`, model).subscribe
      ((data: BObjectModel) => {
        if (!data.HasSomeError) {
          this.http.getHttp<BObjectModel>(`${this.indParam.AppParams.apiUrl}api/bobject/getData/GET_MODELS/${this.model.IdentBO}|1/`).subscribe
            ((data: BObjectModel) => {
              if (!data.HasSomeError) {
                this.model.Header.SavedModels = data.Header.SavedModels;
                this.model.ModelName = this.newModelName;
              }
              this.indParam.showSplash(false);
            });

        } else {
          this.indParam.showSplash(false);
        }
      });
  }
}
